'use strict';

import formPrepare from './pages/checkout/formPrepare';
import util from './util';

var naPhone = /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/;
var regex = {
	phone: {
		us: naPhone,
		ca: naPhone,
		fr: /^0[1-6]{1}(([0-9]{2}){4})|((\s[0-9]{2}){4})|((-[0-9]{2}){4})$/,
		it: /^(([0-9]{2,4})([-\s\/]{0,1})([0-9]{4,8}))?$/,
		jp: /^(0\d{1,4}- ?)?\d{1,4}-\d{4}$/,
		cn: /.*/,
		gb: /^((\(?0\d{4}\)?\s?\d{3}\s?\d{3})|(\(?0\d{3}\)?\s?\d{3}\s?\d{4})|(\(?0\d{2}\)?\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/,
		other: /^\(?([0-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/
	},
	postal: {
		us: /^\d{5}(-\d{4})?$/,
		ca: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/,
		fr: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/,
		it: /^([0-9]){5}$/,
		jp: /^([0-9]){3}[-]([0-9]){4}$/,
		cn: /^([0-9]){6}$/,
		gb: /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/,
		other: /^\d{5}(-\d{4})?$/
	},
	notCC: /^(?!(([0-9 -]){13,19})).*$/,
	name: /^[A-ZÀÁÂÃÄÅĀĂĄǍȀȂȦǠẠḀǺḂḄḆĆČÇḈĈĊĎḐḒḊḌḎÐÉĔĚȨḜÊẾỆỀỂỄḘËĖẸȄÈẺȆĒḖḔĘẼḚḞḟǴĞǦĢĜĠḠḪȞḨĤḦḢḤÍĬǏÎÏḮİỊȈÌỈȊĪĮĨĴǰĵḰǨĶḲḴĹĽĻḼḶḸḺŁḾṀṂŃŇŅṊṄṆǸÑÓŎǑÔỐỘỒỔỖÖȪȮȰỌŐȌÒỎƠỚỢỜỞỠȎŌṒṐǪǬÕṌṎȬǾŒṔṖŔŘŖṘṚṜȐȒṞŚṤŠṦŞŜȘṠṢŤŢṰȚṪṬṮÚŬǓÛṶÜǗǙǛǕṲỤŰȔÙỦƯỨỰỪỬỮȖŪṺŲŮŨṸṴẂŴẄẆẈẀẌẊÝŶŸẎỴỲỶȲỸŹŽẐŻẒẔǮa-zàáâãäåāăąǎȀȂȦǠạḀǻḁḃḅḇćčçḉĉċďḑḓḋḍḏðéĕěȩḝêếệềểễḙëėẹȅèẻȇēḗḕęẽḛḟǵğǧģĝġḡḫȟḩĥḧḣḥẖíĭǐîïḯịȉìỉȋīįĩḭĵḱǩķḳḵĺľļḽḷḹḻłḿṁṃńňņṋṅṇǹñóŏǒôốộồổỗöȫȯȱọőȍòỏơớợờởỡȏōṓṑǫǭõṍṏȭǿœṕṗŕřŗṙṛṝȑȓṟśṥšṧşŝșṡṣßťţṱțẗṫṭṯúŭǔûṷüǘǚǜǖṳụűȕùủưứựừửữȗūṻųůũṹṵṿṽẃŵẅẇẉẁẍẋýŷÿẏỵỳỷȳẙỹźžẑżẓẕǯ’'\s\-]+$/,
	simpletext: /^[0-9a-zA-Z .,'-]*$/,
	password: /^(?=.{8,})(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[\W])/,
	email: /^[a-z0-9._%+-]+@([a-z0-9-]+\.)+[a-z]{2,3}$/i,
	hasPOBox: /[p]+(ost)*\.*\s*[o|0]+(ffice)*\.*\s*b[o|0]x/ig,
	message: /^[\w\.\,\!\?\;\:\(\)\'\" \n]*$/,
	ordernumber: /^[0-9a-z\s-\(\)#]*$/i,
	cvn: /^\d{3,4}$/,
	alphanumeric: /^[a-z0-9]+$/i,
	addr2regex: /^[0-9a-zA-Z .,'#]*$/,
	city: /^[A-ZÀÁÂÃÄÅĀĂĄǍȀȂȦǠẠḀǺḂḄḆĆČÇḈĈĊĎḐḒḊḌḎÐÉĔĚȨḜÊẾỆỀỂỄḘËĖẸȄÈẺȆĒḖḔĘẼḚḞḟǴĞǦĢĜĠḠḪȞḨĤḦḢḤÍĬǏÎÏḮİỊȈÌỈȊĪĮĨĴǰĵḰǨĶḲḴĹĽĻḼḶḸḺŁḾṀṂŃŇŅṊṄṆǸÑÓŎǑÔỐỘỒỔỖÖȪȮȰỌŐȌÒỎƠỚỢỜỞỠȎŌṒṐǪǬÕṌṎȬǾŒṔṖŔŘŖṘṚṜȐȒṞŚṤŠṦŞŜȘṠṢŤŢṰȚṪṬṮÚŬǓÛṶÜǗǙǛǕṲỤŰȔÙỦƯỨỰỪỬỮȖŪṺŲŮŨṸṴẂŴẄẆẈẀẌẊÝŶŸẎỴỲỶȲỸŹŽẐŻẒẔǮa-zàáâãäåāăąǎȀȂȦǠạḀǻḁḃḅḇćčçḉĉċďḑḓḋḍḏðéĕěȩḝêếệềểễḙëėẹȅèẻȇēḗḕęẽḛḟǵğǧģĝġḡḫȟḩĥḧḣḥẖíĭǐîïḯịȉìỉȋīįĩḭĵḱǩķḳḵĺľļḽḷḹḻłḿṁṃńňņṋṅṇǹñóŏǒôốộồổỗöȫȯȱọőȍòỏơớợờởỡȏōṓṑǫǭõṍṏȭǿœṕṗŕřŗṙṛṝȑȓṟśṥšṧşŝșṡṣßťţṱțẗṫṭṯúŭǔûṷüǘǚǜǖṳụűȕùủưứựừửữȗūṻųůũṹṵṿṽẃŵẅẇẉẁẍẋýŷÿẏỵỳỷȳẙỹźžẑżẓẕǯ’'\s\-]+$/
};
// global form validator settings
var settings = {
	errorClass: 'error',
	errorElement: 'span',
	onkeyup: false,
	onfocusout: function (element) {
		if (!this.checkable(element)) {
			this.element(element);
		}
	},
	errorPlacement: function(error, element) {
		$(element).parents('.form-row').find('.error-placement').remove();
		if($(element).parent().find('select').length == 0){
			$("<div class='error-placement'><i class='error-icon'></i><span class='error'>"+$(error).html()+"</span></div>").insertBefore($(element).parent());
		} else{
			stateValidation();
		}
	},
	ignore: ":hidden, .ignore"
};

/**
 * @function
 * @description Validates a given credit card if it has the correct format
 * @param {String} value of credit card which will be validated
 */
var luhnCheck = (function (arr) {
	return function (ccNum) {
		var len = ccNum.length;
		var bit = 1;
		var sum = 0;
		var val;

		while (len) {
			val = parseInt(ccNum.charAt(--len), 10);
			sum += (bit ^= 1) ? arr[val] : val;
		}

		return sum && sum % 10 === 0;
	};
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
var validatePhone = function (value, el) {
	var country = $(el).closest('form').find('.country option:selected').val()

	if (country == undefined || country.length === 0 || !regex.phone[country.toLowerCase()]) {
		var country = 'other';
	}

	var rgx = regex.phone[country.toLowerCase()];
	var isOptional = this.optional(el);
	var isValid = rgx.test($.trim(value));

	// format the phone number
	$(el).val(value.replace(/^(\d{3})[\s-]*(\d{3})[\s-]*(\d+)$/, "($1) $2-$3"));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isOptional || isValid;
};

/**
 * @function
 * @description Validates that a Address2 is not a Address2
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateAddress2 = function (value, el) {
	var isValid = regex.addr2regex.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
};

/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateOwner = function (value, el) {
	var isValid = regex.notCC.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
};

/**
 * @function
 * @description Validates that a name contains no special characters, except for "-"
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateName = function (value, el) {
	var isValid = regex.name.test($.trim(value));
	if (!$(el).closest('form').hasClass('news-letter-form')) {
		if(!isValid) {
			$(el).addClass('this-is-invalid');
		}
	}
	if ($(el).closest('form').hasClass('news-letter-form') && value !== '') {
		if(!isValid) {
			$(el).addClass('this-is-invalid');
		}
	}
	return isValid;
};

var validateFirstName = function (value, el) {
	var message;
	if ($(el).closest('form').hasClass('news-letter-form')) {
		if ($(el).val() === '') {
			message = Resources.VALIDATE_REQUIRED;
		} else {
			message = Resources.INVALID_FIRSTNAME;
		}
	} else {
		message = Resources.INVALID_FIRSTNAME;
	}

	return message;
}


var validateLastName = function (value, el) {
	var message;
	if ($(el).closest('form').hasClass('news-letter-form')) {
		if ($(el).val() === '') {
			message = Resources.VALIDATE_REQUIRED;
		} else {
			message = Resources.INVALID_LASTNAME;
		}
	} else {
		message = Resources.INVALID_LASTNAME;
	}

	return message;
}


var validateEmailField = function (value, el) {
	var message;
	if ($(el).closest('form').hasClass('news-letter-form')) {
		if ($(el).val() === '') {
			message = Resources.VALIDATE_FIRSTNAME;
		} else {
			message = Resources.Resources.INVALID_FIELD;
		}
	} else {
		message = Resources.Resources.INVALID_FIELD;
	}

	return message;
}

/**
 * Add phone validation method to jQuery validation plugin.
 * Text fields must have 'phone' css class to be validated as phone
 */
$.validator.addMethod('phone', validatePhone, Resources.INVALID_PHONE);

/**
 * Add CCOwner validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 */
$.validator.addMethod('owner', validateName, Resources.INVALID_OWNER);

/**
* Add Address2 validation method to jQuery validation plugin.
* Text fields must have 'address2' css class to be validated as address2
*/
$.validator.addMethod('address2', validateAddress2, Resources.INVALID_FIELD);

/**
 * Add First and Last Name validation method to jQuery validation plugin.
 * Text fields must have 'firstname' or 'lastname' css class to be validated.
 */
$.validator.addMethod('firstname', validateName, validateFirstName);
$.validator.addMethod('lastname', validateName, validateLastName);
$.validator.addMethod('fullname', validateName, simpleTextMessage);

$.validator.addMethod('simpletext', function (value) {
	var isValid = regex.simpletext.test($.trim(value));

	return isValid;
}, simpleTextMessage);

$.validator.addMethod('city', function (value, element) {
	var isValid = regex.city.test($.trim(value));  
	if(!isValid) {
		$(element).addClass('this-is-invalid');
	}
	return isValid;
}, simpleTextMessage);

$.validator.addMethod('termsConditionCheckbox', function (value, element) {
	return $(element).is(":checked");    
}, requiredMessage);

$.validator.addClassRules({
	city: {
		city: true
	},
	address1: {
		simpletext: true,
		address: true
	},
	province: {
		simpletext: true
	},
	termsConditionCheckbox: {
		required: true
	}
});

/**
 * Add Alphanumeric method to jQuery validation plugin.
 * Text fields must have 'alphanumeric' css class to be validated.
 */
$.validator.addMethod('alphanumeric', function(value, element){
	var isValid = regex.alphanumeric.test($.trim(value));
	if(!isValid) {
		$(element).addClass('this-is-invalid');
	}
	return isValid;
}, simpleTextMessage);

/**
 * Modify password validation method of jQuery validation plugin.
 * Text fields must have 'password' css class to be validated.
 */
$.validator.addMethod('create-password', function(value, element){
	var isValid = regex.password.test($.trim(value));
	if(!isValid) {
		$(element).addClass('this-is-invalid');
	}
	return isValid;
}, Resources.VALIDATE_PASSWORD);

/**
 * Modify email validation method of jQuery validation plugin.
 * Text fields must have 'email' css class to be validated.
 */
$.validator.addMethod('email', function(value, el){
	var isValid = regex.email.test($.trim(value));
	if (!$(el).closest('form').hasClass('news-letter-form')) {
		if(!isValid) {
			$(el).addClass('this-is-invalid');
		}
	}
	if ($(el).closest('form').hasClass('news-letter-form') && value !== '') {
		if(!isValid) {
			$(el).addClass('this-is-invalid');
		}
	}
	return isValid;
}, validateEmailField);


/**
 * Add gift cert amount validation method to jQuery validation plugin.
 * Text fields must have 'gift-cert-amont' css class to be validated
 */
$.validator.addMethod('gift-cert-amount', function (value, el) {
	var isOptional = this.optional(el);
	var isValid = (!isNaN(value)) && (parseFloat(value) >= 5) && (parseFloat(value) <= 5000);
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isOptional || isValid;
}, Resources.GIFT_CERT_AMOUNT_INVALID);

/**
 * Add positive number validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
$.validator.addMethod('positivenumber', function (value) {
	if ($.trim(value).length === 0) { return true; }
	return (!isNaN(value) && Number(value) >= 0);
}, ''); // '' should be replaced with error message if needed

/**
 * Add CC number validation method to jQuery validation plugin.
 * Text fields must have 'number' css class to be validated
 */
$.validator.addMethod('number', function (value, element) {	// number == Credit card number
	var isValid = luhnCheck($.trim(value));
	if(!isValid) {
		$(element).addClass('this-is-invalid');
	}
	return isValid;
}, Resources.VALIDATE_NUMBER);

/**
 * Add CVN number validation method to jQuery validation plugin.
 * Text fields must have 'cvn' css class to be validated
 */
$.validator.addMethod('cvn', function (value, element) {
	var isValid = regex.cvn.test($.trim(value));
	if(!isValid) {
		$(element).addClass('this-is-invalid');
	}
	return isValid;
}, Resources.VALIDATE_CVN);

/**
 * Add Order number validation method to jQuery validation plugin.
 * Text fields must have 'ordernumber' css class to be validated
 */
$.validator.addMethod('ordernumber', function (value, element) {
	var isValid = regex.ordernumber.test($.trim(value));
	if(!isValid) {
		$(element).addClass('this-is-invalid');
	}
	return isValid;
}, Resources.INVALID_ORDER_NUMBER);

/**
 * Add equal value validation method to jQuery validation plugin.
 * Text fields must have 'equal-to' css class to be validated
 */
$.validator.addMethod('equal-to', function (value, el) {
	var equalTo = $(el).attr('equal-to');
	var $equalToEl = $(el).closest('form').find(equalTo);
	
	return  value === $equalToEl.val();
	
}, function(value, el){
	var message = $(el).attr('data-required-text');
	return message || Resources.VALIDATE_EQUALTO
});

/**
 * Add address validation method to jQuery validation plugin.
 * Text fields must have 'address1' css class to be validated
 */
$.validator.addMethod('address', function (value, element) {
	// check 'PO BOX' value in string and complement result
	var isValid = !$.trim(value).match(regex.hasPOBox);
	if(!isValid) {
		$(element).addClass('this-is-invalid');
	}
	return isValid;
}, Resources.ADDRESS_PO_BOX_ERROR);

/**
 * Add zipcode validation method to jQuery validation plugin.
 * Text fields must have 'zipcode' css class to be validated
 */
$.validator.addMethod('postal', function (value, el) {
	var $form = $(el).closest('form');
	var $country = $form.find('select[name$="_country"]');
	var selectedCountry = $country.length > 0 ? $country.val().toLowerCase() : 'us';
	
	var rgx = null;
	var isValid = false;
	if($(el).hasClass('global-zip')){
		// if universal, it accepts both US and CN values
		isValid = regex.postal['us'].test($.trim(value)) || regex.postal['cn'].test($.trim(value));
	} else {
		rgx = regex.postal[selectedCountry];
		isValid = rgx.test($.trim(value));
	}
	
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
}, Resources.INVALID_FIELD);

/**
 * Add postcode validation method to jQuery validation plugin.
 * Text fields must have 'postcode' css class to be validated
 * Adding this for China addresses
 */
$.validator.addMethod('postcode', function (value, el) {
	var $form = $(el).closest('form');
	var $country = $form.find('select[name$="_country"]');
	var selectedCountry = $country.length > 0 ? $country.val() : 'us'; 
	
	var rgx = regex.postal[selectedCountry];
	var isValid = rgx.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
}, Resources.INVALID_FIELD);

/**
 * Add message validation method to jQuery validation plugin.
 * Text fields must have 'message' css class to be validated
 */
$.validator.addMethod('message', function (value, el) {
	var isValid = regex.message.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
}, Resources.INVALID_MESSAGE);


var requiredMessage = function(value, el) {
	var message = $(el).attr('data-required-text');
	return message || Resources.INVALID_FIELD
};

var simpleTextMessage = function(value, el) {
	var message = $(el).attr('data-required-text');
	return message || Resources.INVALID_FIELD
};

var passwordMessage = function(value, el) {
	var message = $(el).attr('data-required-text');
	return message || Resources.VALIDATE_PASSWORD
};

var maxLengthMessage = function(value, el) {
	var message = $(el).attr('data-required-text');
	return message || $.validator.format(Resources.VALIDATE_MAXLENGTH)
};

var minLengthMessage = function(value, el) {
	var message = $(el).attr('data-required-text');
	return message || $.validator.format(Resources.VALIDATE_MINLENGTH)
};
var stateValidation = function(){
	var customstateRow = $('.state.form-row label');
	if( $('.state select option:selected').val() == '' || $('.state .ui-selectmenu-text').text() == "Select State"){
		customstateRow.next('.error-placement').remove();
		 $('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">'+ Resources.INVALID_STATE +'</span></div>').insertAfter(customstateRow);
		 $('.state span.ui-selectmenu-button').addClass('dropdownerror');
	} else {
		 $('.state .error-placement').remove();
		 $('.state span.ui-selectmenu-button').removeClass('dropdownerror');
	}
}

$.extend($.validator.messages, {
	required: requiredMessage,
	remote: Resources.VALIDATE_REMOTE,
	email: Resources.INVALID_FIELD,
	address1: Resources.ADDRESS_PO_BOX_ERROR,
	password: passwordMessage,
	url: Resources.VALIDATE_URL,
	date: Resources.VALIDATE_DATE,
	dateISO: Resources.VALIDATE_DATEISO,
	number: Resources.VALIDATE_NUMBER,
	digits: Resources.VALIDATE_DIGITS,
	creditcard: Resources.VALIDATE_CREDITCARD,
	equalTo: Resources.VALIDATE_EQUALTO,
	maxlength: maxLengthMessage,
	minlength: minLengthMessage,
	rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
	range: $.validator.format(Resources.VALIDATE_RANGE),
	max: $.validator.format(Resources.VALIDATE_MAX),
	min: $.validator.format(Resources.VALIDATE_MIN),
	postal: Resources.INVALID_ZIP,
	message: Resources.INVALID_MESSAGE,
	fullname: simpleTextMessage,
	simpletext: simpleTextMessage,
	alphanumeric: simpleTextMessage,
	city: Resources.INVALID_FIELD
});
// Updated code to populate green tick check if the password meets the requirements.
var validator = {
	regex: regex,
	settings: settings,
	init: function () {
		var _self = this;
		$('form:not(.suppress)').each(function () {
			_self.initForm(this);
		}).on('blur', '.create-password', function(){
			var isValid = regex.password.test($.trim($(this).val())),
				currentItem = $(this),
				parentOfCurrent = currentItem.parent('.field-wrapper'),
				topParentofCurrent = parentOfCurrent.parent('.form-row');

			if(isValid == true) {
				topParentofCurrent.find('.error-placement').remove();
				parentOfCurrent.addClass('ticmark').find('.create-password').removeClass('error');
			} else {
				parentOfCurrent.removeClass('ticmark');
			}
		}).on('blur','.passwordconfirm, .newpasswordconfirm', function () {
			var currentItem = $(this),
				currentPassword = $('.create-password').val(),
				confirmPassword = $('.passwordconfirm,.newpasswordconfirm').val(),
				parentOfCurrent = currentItem.parent('.field-wrapper'),
				topParentofCurrent = parentOfCurrent.parent('.form-row'),
				existError = $('.create-password').parent('.field-wrapper').find('span.error').length;

			if((currentPassword === confirmPassword) && existError == 0) {
				topParentofCurrent.find('.error-placement').remove();
				parentOfCurrent.addClass('ticmark').find('.passwordconfirm').removeClass('error');
			} else {
				parentOfCurrent.removeClass('ticmark');
			}
		});
	},
	initForm: function (f) {
		var _self = this;
		var $form = $(f);
		var $submitForm = $form.find('button[type="submit"]:not(.ignore)');
		var fp = formPrepare();
		fp.init({
			formSelector: $form,
			continueSelector: $submitForm
		}, _self.settings);
		$submitForm.click(function(e){
			if($form.find('.error').length == 0){
				return;
			} else {
				$form.addClass('submitted-error');
				$form.data('submitting', false);
			}
			if($(".modal-overlay").length == 0 && $(this).attr('id') != "headersignin"){
				util.scrollToError($('html, body'), $form.find(".error-placement, input.error, span.dropdownerror"), 500);
			}
			else{
				$form.find("input.error").first().focus();
			}
		});
	},
	initStateValidation:function(e) {
		$('.state .ui-selectmenu-button, .state select').on('blur', function(){
			$( "select" ).selectmenu( "refresh" );
			stateValidation();
		});
		$('.state select').on('selectmenuchange', function () {
			stateValidation();
		 });
		
	}
};

export default validator;
